import { ActionIcon, Group, Skeleton, Stack, Text, Tooltip } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { UserSearch } from "shared/components/user/UserSearch";
import { userQueryOptions } from "shared/graphql/users";
import { UserStatus } from "src/gql/graphql";

type UserPickerProps = {
    mode?: "widget" | "form";
    initialValue?: string[];
    onSelectionChange?: (values: string[]) => unknown;
};

export const UserPicker = (props: UserPickerProps) => {
    const [users, setUsers] = useState(props.initialValue ?? []);

    function handleAdd(userId: string) {
        setUsers((u) => [...new Set(u.toSpliced(0, 0, userId))]);
    }

    function handleDelete(userId: string) {
        setUsers((u) => u.filter((it) => it != userId));
    }

    useEffect(() => {
        props.onSelectionChange?.(users);
    }, [users.length]);

    return (
        <Stack>
            {props.mode != "widget" && <UserSearch status={UserStatus.Active} onOptionSubmit={handleAdd} placeholder="Search users..." />}
            {users.map((userId) => (
                <UserCard userId={userId} key={userId} onDelete={() => handleDelete(userId)} />
            ))}
        </Stack>
    );
};

const UserCard = (props: { userId: string; onDelete?: () => unknown }) => {
    const { data, isPending } = useQuery(userQueryOptions({ userId: props.userId }));

    return (
        <Skeleton visible={isPending}>
            <Group justify="space-between">
                <div>
                    <Text size="sm" fw={600}>
                        {data?.user.name}
                    </Text>
                    <Text size="xs" c="dimmed">
                        {data?.user.loginEmail}
                    </Text>
                </div>
                <ActionIcon variant="default" onClick={props.onDelete} aria-label="Remove user">
                    <Tooltip label="Remove">
                        <IconTrash size={16} />
                    </Tooltip>
                </ActionIcon>
            </Group>
        </Skeleton>
    );
};
